import axios from 'axios';
import apiConfig from '../api.config';

export default function checkSmtpConnection(data) {
  const {
    host,
    URIs: { checkSmtpConnection },
  } = apiConfig;

  const uri = `${host}${checkSmtpConnection}`;

  return axios
    .post(uri, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
